import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { FilingFilterUI } from './ui';

export class FilingFilter extends PureComponent {
    static displayName = 'FilingFilterContainer';

    static propTypes = {
        onChange: PropTypes.func,
        name: PropTypes.string,
        value: PropTypes.shape({
            type: PropTypes.string,
            operator: PropTypes.string,
            value: PropTypes.any
        })
    };

    static defaultProps = {
        onChange: undefined,
        name: 'filingFormFilter',
        value: null
    };

    render() {
        const { name, value, onChange } = this.props;
        return <FilingFilterUI value={value} onChange={onChange} name={name} />;
    }
}

export const FilingFilterContainer = compose()(FilingFilter);
